<template>
  <div class="bg-white shadow-sm">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
